"use client";

import { motion } from "motion/react";

import { FloatingWrapper } from "./floating-images.wrapper";
import { FloatingElement } from "./floating-images.element";
import {
  useFloatingImages,
  UseFloatingImagesProps,
} from "./use-floating-images";
import { floatingImagesVariants } from "./floating-images.variants";

export type FloatingImagesProps = UseFloatingImagesProps;

export const FloatingImages = (props: FloatingImagesProps) => {
  const { images } = useFloatingImages(props);
  const styles = floatingImagesVariants();

  return (
    <FloatingWrapper sensitivity={-1} className={styles.floatingWrapper()}>
      {images.map((image) => (
        <FloatingElement
          key={image.id}
          depth={image.depth}
          className={image.wrapperClassName}
        >
          <motion.img
            initial={{ opacity: 0 }}
            src={image.src}
            className={image.className}
          />
        </FloatingElement>
      ))}
    </FloatingWrapper>
  );
};
